import axios from "axios";
import Cookies from "js-cookie";
import CONFIG from '../config';
import Storage from '../session/storage';

axios.interceptors.request.use(function (config) {
    // const accessToken = Cookies.get("accessToken");
    const accessToken = Cookies.get("accessToken");
    config.headers.Authorization = `Bearer ${accessToken}`;
    return config;
});

const api = {
    baseUrl: CONFIG.BASE,
    /**
     * global Search API
     * @param {*} entity : type
     * @param {*} search : text
     * @param {*} country : country
     * @param {*} type : flag for type head
     * @returns Observable
     */
    getGlobalSearch: (entity, search, country, type) => {
        return axios.post(api.baseUrl + 'search/global',
            {
                index: ((entity.length === 1) ? entity[0] : 'EPH_*'),
                term: search,
                country: country,
                type_ahead: type !== undefined ? type : undefined
            });

    },
    /**
     * Global Search Count Api
     * @param {*} entity : Entity
     * @param {*} search : text
     * @param {*} country : country
     * @returns Observable
     */
    getGlobalSearchCount: (entity, search, country) => {
        return axios.post(api.baseUrl + 'search/global/count',
            {
                index: ((entity.length === 1) ? entity[0] : 'EPH_*'),
                term: search,
                country: (country.length === 0 ? Storage.getPickList().Country : country)
            });

    },
    /**
     * Advance API 
     * @param {*} entity : type 
     * @param {*} operation : filter query
     * @param {*} relation : relation query
     * @param {*} country : country
     * @param {*} search : text for Dual search
     * @param {*} strict : strict flag
     * @returns 
     */
    getAdvanceSearch: (entity, operation, relation, country, search, strict, type) => {
        let body = search.length === 0 ? {
            index: entity,
            filter: operation,
            relation: relation,
            country: country,
            strict: strict ? 'Y' : 'N'
        } : {
            index: entity,
            filter: operation,
            relation: relation,
            country: country,
            term: search,
            strict: strict ? 'Y' : 'N',
            type_ahead: type !== undefined ? type : undefined
        };
        let uri = search.length === 0 ? "search/advanced" : "search/dual";
        return axios.post(api.baseUrl + uri, body);

    },
    /**
    * Advance Count API 
    * @param {*} entity : type 
    * @param {*} operation : filter query
    * @param {*} relation : relation query
    * @param {*} country : country
    * @param {*} search : text for Dual search
    * @param {*} strict : strict flag
    * @returns 
    */
    getAdvanceSearchCount: (entity, operation, relation, country, search, strict) => {
        let body = search.length === 0 ? {
            index: entity,
            filter: operation,
            relation: relation,
            country: country,
            strict: strict ? 'Y' : 'N'
        } : {
            index: entity,
            filter: operation,
            relation: relation,
            country: country,
            term: search,
            strict: strict ? 'Y' : 'N'
        };
        let uri = search.length === 0 ? "search/advanced/count" : "search/dual/count";
        return axios.post(api.baseUrl + uri, body);

    },
     // Subscribe Api
     subscribeProfile: (updatedValue) => {
        return axios.post(api.baseUrl + 'new-subscription',
            {
                updatedValue
            });


    },
    /**
     * user detail api
     * @param {*} email 
     * @returns {Promise<AxiosResponse>}
     */
    termsConditionAccepted: (email, termsConditions_accepted) => {
        if (email === undefined) {
            return axios.post(api.baseUrl + 'user-roles/termsConditions?agreed='+termsConditions_accepted);
        } else {
            return axios.get(api.baseUrl + 'user-roles?user_email=' + email);
        }
    },
    /**
     * Detail View API
     * @param {*} id 
     * @param {*} entity 
     * @param {*} user 
     * @returns {Promise<AxiosResponse>}
     */
    getUserDetails: (id, entity, user, editFlag) => {
        return axios.get(api.baseUrl + 'view-profile?entity_id=' + id + '&entity_type=' + entity + (editFlag == undefined ? '&user=' + user : '&user=' + user + '&edit=' + editFlag))
    },
    /**
     * Picklist API
     * @param {*} country 
     * @param {*} source 
     * @returns {Promise<AxiosResponse>}
     */
    getPickList: (country, source, specialty, entityType, isNewHCO, locale='en') => { 
        if (country === undefined) {
            // return axios.get(api.baseUrl + `ui-picklist?locals=${'de-DE'}`);
            return axios.get(api.baseUrl + `ui-picklist?locale=${locale}`);
        }else if(source === undefined && isNewHCO === undefined){
            return axios.post(api.baseUrl + 'ui-picklist-lov-bounded',{
                country: [country],
                get_specialty_flag: true,
                // locale: 'en-CA'
                locale: locale
            });
        }else if(source === undefined && isNewHCO === true){
            return axios.post(api.baseUrl + 'ui-picklist-lov-bounded',{
                country: [country],
                get_new_lovs: true,
                entity_type: entityType,
                // locale: 'en-CA'
                locale: locale
            });
        }
        else if(specialty === undefined){
            return axios.post(api.baseUrl + 'ui-picklist-lov-bounded',{
                country: [country],
                source: [source],
                entity_type: entityType,
                // locale: 'en-CA'
                locale: locale
            });
        }else {    
            return axios.post(api.baseUrl + 'ui-picklist-lov-bounded',{
                country: [country],
                specialty: specialty,
                entity_type: entityType,
                // locale: 'en-CA'
                locale: locale
            })
        }
    },
    /**
     * DCR API
     * @param {*} updatedValue 
     * @returns {Promise<AxiosResponse>}
     */
    postUpdate: (updatedValue,originalValue) => {
        return axios.post(api.baseUrl + 'raise-dcr-request', (Object.keys(originalValue).length > 0 ? { updatedValue, originalValue} : {updatedValue} ));
    },
    /**
     * DCR Request API
     * @param {*} reqId 
     * @returns {Promise<AxiosResponse>}
     */
    getAllRequest: (IsAdmin, requestType, reqId, token, filterData) => {
        const dcrStatusUrl = api.baseUrl + 'dcr-status';
        const isEmpty = (value) => value === null || value === undefined;

        if (IsAdmin && reqId) {
            const isInitialFilteredLoad = token === undefined && requestType == null && typeof reqId !== 'string';

            if (isInitialFilteredLoad) {
                return axios.get(`${dcrStatusUrl}?requestPage=allDcr`, { params: reqId });
            }

            return axios.get(`${dcrStatusUrl}?requestPage=allDcr&requestType=${requestType}&nextToken=${token}`, { params: reqId });
        }

        if (IsAdmin && requestType && isEmpty(reqId) && token) {
            return axios.get(`${dcrStatusUrl}?requestPage=allDcr&requestType=${requestType}&nextToken=${token}`);
        }

        if (IsAdmin && requestType == null && isEmpty(reqId) && token === undefined) {
            return axios.get(`${dcrStatusUrl}?requestPage=allDcr`);
        }

        if (!IsAdmin && requestType == null && reqId) {
            return axios.get(`${dcrStatusUrl}?cr_id=${reqId}`);
        }

        if (filterData && Object.keys(filterData).length > 0) {
            return axios.get(dcrStatusUrl, { params: filterData });
        }

        return axios.get(dcrStatusUrl);
    },
    /**
     * Raise Country Access
     * @param {*} body 
     * @returns {Promise<AxiosResponse>}
     */
    getCountryAcces: (body) => {
        return axios.post(api.baseUrl + 'access-management/raise-request', body);
    },
    /**
     * Lilly Country List 
     */
    getSelectedDCRCountry: () => {
        return axios.get(api.baseUrl + 'get-dcr-enabled-countries');
    },
    /**
     * User Access REquest API
     * @param {*} name 
     * @returns {Promise<AxiosResponse>}
     */
    getUserAccessRequest: (name) => {
        return axios.get(api.baseUrl + 'get-requests/' + name);
    },
    postMergeRequest: (body) => {
       
        return axios.post(api.baseUrl + 'merge-request', body);

    },

    getIqviaDetails: (type,value) => {
        if(type.length > 0)
        {   
            // let queryString = ''
            // Object.entries(value).forEach(([key,value])=> {
            //     queryString += '&'+key+'='+value
            // })
           
        
            return axios.get(api.baseUrl + 'iqvia-search?type='+ type,{params:value});


        }else{
            return axios.get(api.baseUrl + 'iqvia-search');
        }
    },

    trackRequest: () => {
        return axios.get(api.baseUrl + 'get-merge-requests');
     },

    getMergeRequest: (id) => {

        return axios.get(api.baseUrl + 'get-merge-requests?id='+id);

    },
    /**
     * Api for HCP consents
     */
    getConsents : (hcpId) =>{
        return axios.get(api.baseUrl + 'get-consent-data?hcpReferenceId='+hcpId)
    },


    /**
     * 
     * @returns {Promise<AxiosResponse>}
     */
    approveMergeRequest: (body) => {
        
        return axios.post(api.baseUrl + 'merge-request-approve' , body);

    },


    /**
     * get All Request
     * @returns {Promise<AxiosResponse>}
     */
    getGroupUsers: () => {
        return axios.get(api.baseUrl + 'get-all-users');
    },

    /**
     // get user details for merge request approve
    * @returns {Promise<AxiosResponse>}
     */
    getUserRole :()=>{
        return axios.get(api.baseUrl +'user-roles');
    },

    // to validate the user that user is present or not in our system
    validateUser: ()=>{
        return axios.get(api.baseUrl +'user-roles/checkUserExists');
    },

    /**
     * Manage Access API
     * @param {*} country 
     * @param {*} id 
     * @param {*} operation 
     * @param {*} role 
     * @param {*} email 
     * @returns {Promise<AxiosResponse>}
     */
    manageAccess: (country, id, operation, role, email) => {
        let body = { "operation": operation, "country": country, role }
        if (operation === 'add') {
            body = {
                ...body,
                user_email: email
            }
        } else {
            body = {
                ...body,
                "user_id": id
            }

        }
        return axios.post(api.baseUrl + 'access-management/process-request', body);
    },
    /**
     * Pending Country Access
     * @returns {Promise<AxiosResponse>}
     */
    getAllPending: () => {
        return axios.get(api.baseUrl + 'access-requests');
    },
    /**
   * DCR Filter API
   * @param {*} body
   * @returns {Promise<AxiosResponse>}
   */
    getFilterRequest: (body) => {
      return axios.post(api.baseUrl + "eph-dcr", body);
    },
    /**
   * DCR Approve API
   * @param {*} body
   * @returns {Promise<AxiosResponse>}
   */
     dcrApprove: (body) => {
        if (!body.reviewerComments) {
            body.reviewerComments = "";
         } 
        return axios.put(api.baseUrl + 'dcr-actions/approve', body);
      },
    /**
   * DCR Reject API
   * @param {*} body
   * @returns {Promise<AxiosResponse>}
   */
    dcrReject: (body) => {
        if (!body.reviewerComments) {
            body.reviewerComments = "";
         } 
        return axios.put(api.baseUrl + 'dcr-actions/reject', body);
      },
    
    /** 
    * DCR Reject API
    * @param {*} body
    * @returns {Promise<AxiosResponse>}
    */
    dcrAssign: (assign, dcrIds, requestType) => {
        return axios.put(api.baseUrl + 'dcr-actions/assign ', {
            assign : assign,
            dcrIds : dcrIds,
            requestType: requestType
        });
      },

  listPotentialMatches: () => {
    return axios.get(api.baseUrl + '/dcr-potential-matches')
  },

  viewPotentialMatchById: (id) => {
    return axios.get(api.baseUrl + '/dcr-potential-matches', {
      params: {
        id: id
      }
    })
  },

  confirmPotentialMatch: (data) => {
    return axios.post(api.baseUrl + '/dcr-potential-matches', data)
  },

  listNoMatches: () => {
    return axios.get(api.baseUrl + '/dcr-no-match')
  },

  viewNoMatchById: (id) => {
    return axios.get(api.baseUrl + '/dcr-no-match', {
      params: {
        id: id
      }
    })
  },

  confirmNoMatch: (data) => {
    return axios.post(api.baseUrl + '/dcr-no-match', data)
  },

  /**
   * Upload CSV & XSLX chunk for transliteration,bulk upload, bulk search
   * @param {FormData} formData - Contains chunked file data.
   * @returns {Promise<AxiosResponse>}
   */

  uploadTransliterationChunk: (formData) => {
    return axios.post(api.baseUrl + "bulk-file-upload", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      timeout: 60000, // 60 second timeout
    });
  },

  /**
   * Fetch bulk search results with pagination
   * @param {string} uploadId - The upload ID
   * @param {number} index - The page index starting from 0
   * @returns {Promise<AxiosResponse>}
   */

  fetchBulkSearchResults: (data) => {
    return axios.post(api.baseUrl + "bulk-search-request-fetch", data, {});
  },

  fetchUploadHistory: (appId, cursor) => {
    return axios.get(api.baseUrl + "user-bulk-upload-history", {
      params: {
        appid: appId,
        cursor: cursor,
      },
    });
  },

  fetchBulkUploadResults: (uploadId, cursor, pendingStatus) => {
    return axios.get(api.baseUrl + "user-bulk-dcr-results", {
      params: {
        uploadId: uploadId,
        cursor: cursor,
      },
    });
  },
  bulkHistoryDownload: (appId, cursor, uploadId, createdAt) => {
    return axios.get(api.baseUrl + "user-bulk-file-download", {
      params: {
        cursor: cursor,
        uploadid: uploadId,
      },
    });
  },
    batchSearchResult: (data) => {
    return axios.post(api.baseUrl + "process-relevant-results", data, {});
  },

   fetchVendorSearch: (data) => {
    return axios.post(api.baseUrl + "on-demand-vendor-search", data, {});
  },
  fetchVendorSearchPolling: (data) => {
    return axios.post(api.baseUrl + "bulk-vendor-search-results", data, {});
  },

  fetchHcaRequests: (params = {}) => {
    return axios.get(api.baseUrl + "hca-requests", {
      params,
    });
  },
   fetchBulkSearchSummery: (data) => {
   return axios.post(api.baseUrl + "bulk-search-summary", data, {});
 },

 triggerBatchResult: (data) => {
   return axios.post(api.baseUrl + "trigger-consent-workflow", data, {});
 },

  bulkConsentResult: (data) => {
   return axios.post(api.baseUrl + "bulk-econsent-results", data, {});
 },
 
 fetchAutoProcessResults: (data) => {
   return axios.post(api.baseUrl + "fetch-auto-process-results", data, {});
 },
 
};

export default api;